import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';

const defaultTrackEvent = {
  type: GPX_EVENT_TYPES.CLICK,
  feature: GPX_FEATURES.TF911_PRECONFIGURED_RESPONSES,
  capability: GPX_CAPABILITIES.TF911,
  route: GPX_ROUTES.COMMUNICATOR,
};

export const trackToggleSuggestedResponse = (
  isGoingToBeEnabled = false,
  message: PreconfiguredResponse,
) => {
  const isEnabledString = isGoingToBeEnabled ? 'enable' : 'disable';

  gspx.trackEvent({
    ...defaultTrackEvent,
    name: `${isEnabledString}_suggested_response`,
    entities: {
      title: message.title,
      body: message.body,
      id: message.id,
    },
  });
};

export const trackCreatePreconfiguredResponse = (
  message: Partial<PreconfiguredResponse>,
) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'create_preconfigured_response',
    entities: {
      title: message.title,
      body: message.body,
      id: message.id,
    },
  });
};

export const trackEditPreconfiguredResponse = (
  message?: PreconfiguredResponse | null,
) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'edit_preconfigured_response',
    entities: {
      title: message?.title,
      body: message?.body,
      id: message?.id,
    },
  });
};

export const trackDeletePreconfiguredResponse = (
  message: PreconfiguredResponse,
) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'delete_preconfigured_response',
    entities: {
      title: message.title,
      body: message.body,
      id: message.id,
    },
  });
};
